// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"afec9bc3","455":"5fb2047c"}[chunkId] + ".chunk.js";
};